export const UPDATE_CASE_SELECT = 'UPDATE_CASE_SELECT'

export interface UpdateCaseSelect {
    type: typeof UPDATE_CASE_SELECT;
    payload:  string[];
}

